export default __webpack_public_path__ + "static/media/goopter-bellabot-smart-expressions.80a02b26.png";